export default __webpack_public_path__ + "static/media/promo.faf1f6b1.png";